import React, { useEffect } from "react";
import { useFilters, useSortBy, useTable } from "react-table";
import { Link } from "react-router-dom";

import SortIcon from "@mui/icons-material/Sort";
import { Table } from "@deere/ux.uxframe-react";
import "./WtyReportTable.css";
import { useSelector } from "react-redux";
import { languageResponseData } from "../../Translation/translationSerachSlice";

export function WtyReportTable({
  columns,
  data,
  dataType,
  searchFrom,
  machineSearchType,
}) {
  /*Hide the Dealer column is the search is made for the Machines of a Dealer*/
  /*if (machineSearchType === 'dealer') {
        columns = columns.filter(column => column.accessor !== 'responsibleDealer')
    }*/
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns,
        data,
      },
      useFilters,
      useSortBy
    );
  const translationsResponse = useSelector(languageResponseData);
  const translate = (key, defaultText) => {
    return translationsResponse[key] || defaultText;
  };

  function columnWithLink(column) {
    return (
      column.Header === translate("claim", "Claim#") ||
      column.Header === translate("pin", "Pin")
    );
  }

 

  return (
    <Table className="table table-sm table-uxf-modern" {...getTableProps()}>
      <thead>
        {headerGroups.map((headerGroup) => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column) => (
              <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  {column.render("Header")}
                  <SortIcon className="exclude-from-print" />
                </div>

                {column.canFilter ? column.render("Filter") : null}
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row) => {
          prepareRow(row);
          return (
            <tr key={row.id} {...row.getRowProps()}>
              {row.cells.map((cell) => (
                <td {...cell.getCellProps()}>
                  {columnWithLink(cell.column)
                    ? createLink(cell, dataType, searchFrom, machineSearchType)
                    : cell.render("Cell")}
                </td>
              ))}
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
}

/*@param: machineSearchType
 * machineSearchType is used only for machine list to display and hide the dealer number column if the machine search is perform for a dealer.
 * @param: dataType, values: 'Claim#', 'Pin'
 * dataType is used to add correct hyperlink on either Pin or Claim Number column.
 *
 * */
function createLink(cell, dataType, searchFrom, machineSearchType) {
  let pathName = "";
  let state = {};

  if (dataType === "ClaimData") {
    pathName = `/claim-search/claimNumber/${cell.row.original["claimNumber"]}`;
    state = {
      searchFrom: searchFrom,
    };
  } else if (dataType === "MachineData") {
    pathName = `/machine-details/pin/${cell.row.original["pin"]}`;
    state = {
      pinNumber: cell.row.original["pin"],
      machineSearchType: machineSearchType || null,
    };
  }
  return (
    <Link
      to={{
        pathname: pathName,
        state: state,
      }}
      onFocus={(e) => {
        e.target.style.color = "grey";
      }}
    >
      {cell.render("Cell")}
    </Link>
  );
}

// Custom filter component
export function TextFilter({ column }) {
  const { setFilter } = column;
  // Stop the sorting behaviour when user click inside the filter input
  const handleInputClick = (e) => {
    e.stopPropagation();
  };
  return (
    <input
      className="exclude-from-print"
      value={column.filterValue || ""}
      onChange={(e) => setFilter(e.target.value || undefined)}
      onClick={handleInputClick}
      placeholder={`Filter ${column.Header}`}
    />
  );
}
